import * as React from "react";
import {MouseEvent} from "react";
import Style from "../../../_data/models/Style";
import {formatWithTags, prettyPrintComment} from "../../../_helpers/utils";
import LikeComponent from "../../../_widgets/like/LikeComponent";
import Meta from "../../../_data/models/Meta";
import CommentsContainer from "../../../comment/containers/CommentsContainer";
import {CommentsState} from "../../../_definitions/styleteq";
import UserRedirectContainer from "../../../_widgets/user/UserRedirectContainer";
import User from "../../../_data/models/User";
import {ResourceType} from "../../../_helpers/data";


interface Props {
    user: User;
    style: Style;
    toggleLike: (e: MouseEvent<HTMLElement>) => void;
    loadMoreComments: (meta: Meta) => void;
    comments: CommentsState;
}

const ModalStyleComponent = (props: Props) => {
    const {style, toggleLike, loadMoreComments, comments} = props;
    const user = style.user;
    return (
        <div className="row" style={{margin: 0}}>
            <div className="large-8 medium-8 columns">
                <div className="row p1">
                    <div className="large-12 columns paddingless">
                        <ul className="list-inline marginless">
                            <li>
                                <UserRedirectContainer id={user.id} element="a">
                                    <img src={user.profilePicture()} className="img-wrapper circle"/>
                                </UserRedirectContainer>
                            </li>
                            <li>
                                <UserRedirectContainer id={user.id} element="a">
                                    <h5 className="inline">{user.username()}</h5>
                                </UserRedirectContainer>
                            </li>
                            {user.isProfessional &&
                            <li className="float-right">
                                <UserRedirectContainer className="button mb-0" id={user.id} element="a" type={ResourceType.message}>
                                    <i className="fa fa-envelope-o fa-fw"/>&nbsp; Message
                                </UserRedirectContainer>
                            </li>
                            }
                        </ul>
                    </div>
                </div>
                <div className="row mb-1">
                    <div className="large-12 columns">
                        <div className="post-img v-align-center" style={{lineHeight: "30rem"}}>
                            <a data-open="postmodal" aria-controls="postmodal" id="q36vqn-reveal"
                               aria-haspopup="true" tabIndex={0}>
                                <img src={style.primaryPictureUrl} alt=""/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="large-4 medium-4 columns bl-1">
                {style.description.trim().length > 0 &&
                <div className="row p1 bb-1">
                    <div className="large-12 columns paddingless">
                        <p className="mt-1 word-wrap-break">{formatWithTags(style.description)}</p>
                    </div>
                </div>
                }
                <div className="row bb-1">
                    <div className="large-12 columns pt-half pb-half">
                        <ul className="list-inline marginless newsfeed-rgfont">
                            <LikeComponent likable={style} toggleLike={toggleLike}/>
                            <li>
                                <i className="fa fa-comment-o fa-fw"/> {prettyPrintComment(style)}
                            </li>
                        </ul>
                    </div>
                </div>
                {(!comments.meta || (comments.meta && comments.items.length > 0)) &&
                <CommentsContainer items={comments} loadMoreComments={loadMoreComments}/>
                }
            </div>
        </div>
    );
};
export default ModalStyleComponent;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/modal/components/ModalStyleComponent.tsx